// src/modules/auth/utils/auth.utils.ts
import axiosInstance from "../../../middlewares/axiosInstance";

export const authUtils = {
  setTokens(accessToken: string, refreshToken: string) {
    try {
      // Validate tokens are not empty or undefined
      if (!accessToken || !refreshToken) {
        throw new Error("Invalid tokens provided");
      }

      // Store tokens in localStorage
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("refreshToken", refreshToken);

      // Set axios authorization header
      axiosInstance.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${accessToken}`;

      // Verify tokens were stored correctly
      const storedAccessToken = this.getAccessToken();
      const storedRefreshToken = this.getRefreshToken();

      if (!storedAccessToken || !storedRefreshToken) {
        throw new Error("Failed to store tokens");
      }
    } catch (error) {
      console.error("Error setting tokens:", error);
      this.clearTokens(); // Clean up if something goes wrong
      throw error;
    }
  },

  clearTokens() {
    try {
      // Clear tokens
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      
      // Clear user-related data
      localStorage.removeItem("userId");
      localStorage.removeItem("storeId");
      localStorage.removeItem("storeName");
      localStorage.removeItem("storeDisplayId");
      localStorage.removeItem("pos_session_id");
      localStorage.removeItem("pos_session_data");
      
      // Clear axios authorization header
      if (axiosInstance && axiosInstance.defaults && axiosInstance.defaults.headers) {
        delete axiosInstance.defaults.headers.common["Authorization"];
      }
      
      // Force clear any cached responses
      if (window.caches) {
        caches.keys().then(names => {
          names.forEach(name => {
            caches.delete(name);
          });
        });
      }
    } catch (error) {
      console.error("Error clearing tokens:", error);
    }
  },

  getAccessToken(): string | null {
    try {
      const token = localStorage.getItem("accessToken");
      return token;
    } catch (error) {
      console.error("Error getting access token:", error);
      return null;
    }
  },

  getRefreshToken(): string | null {
    try {
      const token = localStorage.getItem("refreshToken");
      return token;
    } catch (error) {
      console.error("Error getting refresh token:", error);
      return null;
    }
  },

  isAuthenticated(): boolean {
    try {
      const accessToken = this.getAccessToken();
      return !!accessToken;
    } catch (error) {
      console.error("Error checking authentication:", error);
      return false;
    }
  },

  // New helper methods
  hasValidTokens(): boolean {
    return !!(this.getAccessToken() && this.getRefreshToken());
  },

  getAuthHeader(): string | null {
    const accessToken = this.getAccessToken();
    return accessToken ? `Bearer ${accessToken}` : null;
  },
};
